import type { CountryResource } from "../../country";
import type { VariantResource } from "../../variant";
import type { CustomerResource } from "../../customer";
import type { CustomerGroupResource } from "../../customer-group";
import type { ProductGroupResource } from "../../product-group";

export interface ShippingCostRuleNewForm {
  calculation_rules: { title: string; value: number }[];
  calculation_types: { title: string; value: string }[];
  carriers: Carrier[];
}

export enum CalculateTypeEnum {
  Size = "s",
  Weight = "w",
  Price = "p",
  Amount = "a",
}
export interface ShippingCostRuleResource {
  id: string;
  title: string;
  is_active: boolean;
  is_addsum_percent: boolean;
  is_addsum_net: boolean;
  is_addsum_cod_net: boolean;
  is_cod_allowed: boolean;
  addsum: string;
  addsum_cod: string;
  calculation_types: { title: string; value: string }[];
  calculate_type_1: CalculateTypeEnum;
  param_from_1: number;
  param_to_1: number;
  calculation_rules: { title: string; value: string }[];
  carriers: Carrier[];

  calculate_type_2: CalculateTypeEnum;
  param_from_2: number;
  param_to_2: number;

  is_param_net: boolean;
  calculate_rule: number;
  carrier_id: string;
  carrier_params: { [param_name: string]: string };
  deliveries?: ShippingCostRuleResource[];
  deliveries_count?: number;

  excluded_variants?: VariantResource[];
  excluded_variants_count: number;
  included_variants?: VariantResource[];
  included_variants_count: number;

  excluded_product_groups?: ProductGroupResource[];
  excluded_product_groups_count: number;
  included_product_groups?: ProductGroupResource[];
  included_product_groups_count: number;

  excluded_customer_groups?: CustomerGroupResource[];
  excluded_customer_groups_count: number;
  included_customer_groups?: CustomerGroupResource[];
  included_customer_groups_count: number;

  excluded_countries?: CountryResource[];
  excluded_countries_count: number;
  included_countries?: CountryResource[];
  included_countries_count: number;

  excluded_customers?: CustomerResource[];
  excluded_customers_count: number;
  included_customers?: CustomerResource[];
  included_customers_count: number;
}

export interface Carrier {
  id: string;
  title: string;
  carrier_type: string;
  delivery_service_params?: {
    name: string;
    title: string;
    type: "string" | "select";
    required: boolean;
    options?: { title: string; value: string }[];
  }[];
}

export type UpdateShippingCostRuleRequestBody = {
  title?: string;
  is_active?: boolean;
};

export type StoreShippingCostRuleRequestBody = {
  is_active?: boolean;
  title?: string;
};
